// Copyright (C) 2017, 2018 DecElite LLC - All Rights Reserved. May not be distributed or copied.
<template>
  <v-flex
    xs12
    sm4>
    <v-card
      class="ma-2"
      height="240"
      ripple
      :to="to">
      <v-responsive>
        <v-layout
          justify-space-around
          class="pt-2">
          <v-icon x-large>{{ icon }}</v-icon>
        </v-layout>
      </v-responsive>
      <v-card-title>
        <h2 class="title grey--text text--darken-1">{{ title }}</h2>
      </v-card-title>
      <v-card-text>
        <slot/>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
import * as VGrid from 'vuetify/es5/components/VGrid'
import * as VCard from 'vuetify/es5/components/VCard'
import VResponsive from 'vuetify/es5/components/VImg'
import VIcon from 'vuetify/es5/components/VIcon'

export default {
  props: {
    to: {
      type:    String,
      default: '/help',
    },
    icon: {
      type:    String,
      default: 'help',
    },
    title: {
      type:    String,
      default: 'Help',
    },
  },
  components: {
    ...VGrid,
    ...VCard,
    VIcon,
    VResponsive,
  },
}

</script>
